import {CLEAR_UPLOAD_APK, FETCH_UPLOAD_APK, LIST_UPLOAD_APK} from "./types";

const init = {
    isLoading: true,
    list: [],
    page: 1,
    totals: 0,
    size: 10
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_UPLOAD_APK:
            return {
                ...state,
                isLoading: true
            };
        case LIST_UPLOAD_APK:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                ...payload.paging
            };
        case CLEAR_UPLOAD_APK:
            return {
                ...init
            };
        default:
            return state;
    }
}